import apiClient from './apiClient';
import { Appointment, CreateAppointmentRequest, UpdateAppointmentRequest } from '../types/Appointment';

export const appointmentService = {
  getAllAppointments: async (): Promise<Appointment[]> => {
    const response = await apiClient.get('/appointments');
    return response.data;
  },

  getAppointmentById: async (id: number): Promise<Appointment> => {
    const response = await apiClient.get(`/appointments/${id}`);
    return response.data;
  },

  getAppointmentsByPatient: async (patientId: number): Promise<Appointment[]> => {
    const response = await apiClient.get(`/appointments/patient/${patientId}`);
    return response.data;
  },

  getAppointmentsByDoctor: async (doctorName: string): Promise<Appointment[]> => {
    const response = await apiClient.get(`/appointments/doctor/${encodeURIComponent(doctorName)}`);
    return response.data;
  },

  getAppointmentsByStatus: async (status: string): Promise<Appointment[]> => {
    const response = await apiClient.get(`/appointments/status/${encodeURIComponent(status)}`);
    return response.data;
  },

  getTodaysAppointments: async (): Promise<Appointment[]> => {
    const response = await apiClient.get('/appointments/today');
    return response.data;
  },

  getUpcomingAppointments: async (days: number = 7): Promise<Appointment[]> => {
    const response = await apiClient.get(`/appointments/upcoming?days=${days}`);
    return response.data;
  },

  getAppointmentsByDateRange: async (startDate: string, endDate: string): Promise<Appointment[]> => {
    const response = await apiClient.get(`/appointments/date-range?startDate=${startDate}&endDate=${endDate}`);
    return response.data;
  },

  createAppointment: async (appointment: CreateAppointmentRequest): Promise<Appointment> => {
    // Convert time to TimeSpan format (HH:mm:ss)
    const payload = {
      ...appointment,
      appointmentTime: appointment.appointmentTime ? `${appointment.appointmentTime}:00` : '00:00:00',
    };
    const response = await apiClient.post('/appointments', payload);
    return response.data;
  },

  updateAppointment: async (id: number, appointment: UpdateAppointmentRequest): Promise<Appointment> => {
    // Convert time to TimeSpan format (HH:mm:ss)
    const payload = {
      ...appointment,
      appointmentTime: appointment.appointmentTime ? `${appointment.appointmentTime}:00` : '00:00:00',
    };
    const response = await apiClient.put(`/appointments/${id}`, payload);
    return response.data;
  },

  deleteAppointment: async (id: number): Promise<void> => {
    await apiClient.delete(`/appointments/${id}`);
  }
};